import axios from '@/axios'
import store from '@/store/store'

export default {
  login (payload) {
    return axios.post('/auth/user-password', payload, {
      headers: {
        'Content-Type': 'multipart/form-data;boundary=<calculated when request is sent>',
        'Content-Length': '<calculated when request is sent>',
        'Access-Control-Allow-Origin': '*'
      }
    })
  },
  register (payload) {
    return axios.post('/auth/register', payload)
  },
  registerMitra(data, headers) {
    return axios.post('/input/data-lembaga', data, headers)
  },
  refreshToken (token) {
    return axios.post('/auth/refresh')
  },
  logout () {
    return axios.post('/auth/logout')
  },
  forgotPassword (payload) {
    return axios.post('/auth/forgot', payload)
  },
  emptyToken () {
    return store.getters['auth/profile']
  },
  verify (id) {
    return axios.post(`/auth/verify/${id}`, {})
  },
  saveProfile(payload, headers) {
    return axios.post('/input/user', payload, headers)
  },
  resetPassword(payload, headers) {
    return axios.post(`/auth/change-forgot/${payload.verifyId}`, {
      password: payload.password
    }, headers)
  },
  changePassword(payload, headers) {
    return axios.post(`/user/change-password/${payload.id}`, payload, headers)
  },
  resendEmail(payload, headers) {
    return axios.post(`/auth/resend-email`, payload, headers)
  }
}